import React, { Component } from 'react';
import { styled } from '../../../stitches.config';
import LazyLoad from "react-lazyload";
import Slider from "react-slick";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { withDrawingBoard } from "../../HOCs/withDrawingBoard"

// bizon
import ArrowSlider from "../../../assets/img/arrow-slider.svg"

@withDrawingBoard(props => props.blockData.hasCanvas)
class Carousel extends Component {
    render() {
        const { urls } = this.props.blockData;
        const collageImages = this.props.blockData.redirects === undefined ?
            Object.entries(urls).map(([name, value], index) => (
                <Zoom wrapStyle={{ width: '100%', height: 'auto', alignItems: 'flex-start' }} isZoomed={this.isZoomed} onZoomChange={this.handleZoomChange}>
                    <img key={index} src={value} alt="" style={{ width: "100%" }} />
                </Zoom>
            ))
            :
            Object.entries(urls).map(([name, value], index) => {
                return this.props.blockData.redirects[name] === "" ?
                    <Zoom wrapStyle={{ width: '100%', height: 'auto', alignItems: 'flex-start' }} isZoomed={this.isZoomed} onZoomChange={this.handleZoomChange}>
                        <img key={index} src={value} alt="" style={{ width: "100%" }} />
                    </Zoom> :
                    <a href={this.props.blockData.redirects[name]} target="_blank" rel="" style={{ zIndex: 20 }}>
                        <img key={index} src={value} alt="" style={{ width: "100%" }} />
                    </a>

            })

        const settings = {
            centerMode: true,
            infinite: true,
            centerPadding: 0,
            slidesToShow: 3,
            dots: false,
            arrows: true,
            draggable: false,
            speed: 500,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        dots: true,
                        slidesToShow: 1,
                        centerPadding: "16px",
                        infinite: false,
                        arrows: false
                    }
                }
            ]
        }

        return (
            <LazyLoad once={true} offset={600} height={300}>
                <BizonCarouselWrapper>
                    <Slider {...settings}>
                        {collageImages}
                    </Slider>
                </BizonCarouselWrapper>
            </LazyLoad>
        )

    }

}

const BizonCarouselWrapper = styled("div", {
    width: "100%",
    margin: "0px auto",
    padding: "20px 0 30px 0",
    "@media (min-width: 992px)": {
        margin: "5px auto",
        padding: "30px 0",
        width: "calc(100% - 168px)"
    },
    ".slick-slide.slick-center .Main_wrap__260iu img, .slick-slide.slick-center a": {
        transform: "scale(1.1)",
        transition: "transform 500ms"
    },
    ".slick-slide .Main_wrap__260iu img, .slick-slide a": {
        transition: "transform 300ms",
        width: "inherit",
        objectFit: "cover"
    },
    ".slick-dots": {
        bottom: "-16px",
        li: { margin: "0 8px 0 0", width: "6px", height: "6px" },
        ".slick-active": { "button::before": { color: "$primary" } }
    },
    ".slick-list": {
        "@media (min-width: 992px)": {
            paddingTop: "30px !important",
            paddingBottom: "30px !important"
        },
        ".slick-slide > div": {
            margin: "0 16px 0 0",
            "@media (min-width: 992px)": { margin: "0 12px" }
        }
    },
    ".slick-prev": {
        zIndex: 1000,
        left: "-10px"
    },
    ".slick-next": {
        zIndex: 1000,
        right: "16px"
    },
    ".slick-next:before": {
        transform: "rotate(180deg)"
    },
    ".slick-arrow:before": {
        opacity: 1,
        content: '" "',
        display: "block",
        width: "48px",
        height: "48px",
        borderRadius: "48px",
        backgroundColor: "#131212",
        backgroundImage: `url("${ArrowSlider}")`,
        backgroundPosition: "center",
        backgroundSize: "15px",
        backgroundRepeat: "no-repeat"
    }
});

export default Carousel